import React, {useState} from 'react';
import {View, StyleSheet, TouchableOpacity} from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome';

const CCRating = ({rating: initialRating = 0, onChange}) => {
  const [rating, setRating] = useState(initialRating);

  const handlePress = newRating => {
    setRating(newRating);
    if (onChange) {
      onChange(newRating);
    }
  };

  const renderStars = () => {
    return [...Array(5)].map((_, index) => {
      const starNumber = index + 1;
      return (
        <TouchableOpacity
          key={starNumber}
          onPress={() => handlePress(starNumber)}>
          <Icon
            style={styles.star}
            name={rating >= starNumber ? 'star' : 'star-o'}
            size={28}
            color="#FFD700"
          />
        </TouchableOpacity>
      );
    });
  };

  return <View style={styles.container}>{renderStars()}</View>;
};

export default CCRating;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  star: {
    marginRight: 5,
  },
});
